import { InsideSalesClientBrowsePage } from "./InsideSalesClientBrowsePage";

export function CustomersBrowsePage() {
  return (
    <InsideSalesClientBrowsePage
      title="Customers"
      help="Browse Freshsales sales accounts with category, rep assignments, and any other Freshsales account fields, plus linked Megaventory client and end-user mirror fields. Read-only in Inside Sales."
      searchLabel="Search customers"
      searchPlaceholder="Account name, owner, rep, MV client, end user, or Freshsales id"
      emptySelectionMessage="Select a customer from the list to see Freshsales and Megaventory mirror fields."
    />
  );
}
